module.exports = __webpack_public_path__ + "img/diners-club-mono.823962bf.svg";